module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert van Gulik\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Robert Van Gulik")]), _vm._v(" (1910-67) was a Dutch diplomat and an authority on Chinese history and culture. He drew his plots from the whole body of Chinese literature, especially from the popular detective novels that first appeared in the seventeenth century.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2eUqL4/tc-custom/9780226849010.jpg?1726617300307",
      "alt": "This image is the cover for the book Monkey and The Tiger, The Judge Dee Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Monkey and The Tiger, The Judge Dee Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("The Monkey and The Tiger")]), _vm._v(" includes two detective stories, \"The Morning of the Monkey\" and \"The Night of the Tiger.\" In the first, a gibbon drops an emerald in the open gallery of Dee's official residence, leading the judge to discover a strangely mutilated body in the woods—and how it got there. In the second, Dee is traveling to the imperial capital to assume a new position when he is separated from his escort by a flood. Marooned in a large country house surrounded by fierce bandits, Dee confronts an apparition that helps him solve a mystery."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0